import React from 'react'

const WholeStore = () => {
  return (
    <>
        <div>Coupon is applied to whole store</div>
        <button className='py-2' style={{borderRadius:'8px', backgroundColor:'#41B8E4', color:'white', border:'none'}}>Visit store</button>
    </>
  )
}

export default WholeStore